export default __webpack_public_path__ + "static/media/Esprit.c43e93d6.png";